import React, { useState, useContext } from 'react';
import Menu from './Menu';
import logo from '../assets/images/logo.png'; // Adjust the path as necessary
import { LanguageContext } from '../contexts/LanguageContext'; // Import the LanguageContext

const Header = () => {
    const [menuActive, setMenuActive] = useState(false);

    const toggleMenu = () => {
        setMenuActive(!menuActive);
    };

    const { t } = useContext(LanguageContext); // Access translations

    return (
        <>
        {/* <div className="notification">
            <p>
                {t.notification}
                <a href="mailto:contact@3sss">contact@3sss</a>
            </p>
        </div> */}
        <header className="sticky-header">
            <div className="logo">
                <img src={logo} alt="Company Logo" />
            </div>
            <button className="hamburger" onClick={toggleMenu} aria-label="Toggle navigation menu">
                ☰
            </button>
            <nav className={menuActive ? 'active' : ''}>
                <Menu />
            </nav>
        </header>
        </>
    );
};

export default Header;